// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1OIgn","infoBtn":"quickbooks_infoBtn__4ioHP","formBox":"quickbooks_formBox__32h_5","formFooter":"quickbooks_formFooter__2C4P_"};